import { TimeSlotKey } from "./TimeSlotKey";

export class TimeSlotKeyDto implements ITimeSlotKeyDto {
    constructor(timeSlotKey: TimeSlotKey) {
        this.timeSlotGroupKey = timeSlotKey.timeSlotGroupKey;
        this.timeSlotKey1 = timeSlotKey.timeSlotKey1;
        this.timeSlotKey2 = timeSlotKey.timeSlotKey2;
    }

    timeSlotGroupKey: number;
    timeSlotKey1: string;
    timeSlotKey2: number;
}

export interface ITimeSlotKeyDto {
    timeSlotGroupKey: number;
    timeSlotKey1: string;
    timeSlotKey2: number;
}